import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import Login from './components/Login';
import Register from './components/Register';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';
import SubMastersPage from './components/SubMasters/SubMastersPage';
import BuyerLedgerCreation from './components/BuyerLedger/BuyerLedgerCreation';
import CompanyDetails from './pages/CompanyDetails';
import ClientList from './pages/ClientList';
import WRTBuyer from './pages/WRTBuyer';
import Sales from './pages/Sales';
import DMS from './pages/DMS';
import ProductMaster from './pages/Product';
import Catalog from './pages/Catalog';
import Cart from './pages/Cart';
import ClientCatalog from './pages/ClientCatalog';
import './App.css';
import ProductAuthorization from './pages/Authorization/ProductAuthorization';
import ProformaInvoice from './pages/ProformaInvoice';
import OrderCreation from './pages/Order/OrderCreation';
import OrderSearch from './pages/Order/OrderSearch';
import OrderAuthorization from './pages/Authorization/OrderAuthorization';
import UserAccessControl from './pages/UserAccessControl';
import ModuleRoute from './components/ModuleRoute';

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="product/master/submasters/:type" element={<ModuleRoute moduleKey="product_master"><SubMastersPage /></ModuleRoute>} />
              <Route path="crm-master/submasters/:type" element={<ModuleRoute moduleKey="crm_master"><SubMastersPage /></ModuleRoute>} />
              <Route path="general-master/submasters/:type" element={<ModuleRoute moduleKey="general_master"><SubMastersPage /></ModuleRoute>} />
              <Route path="crm-master/add-client" element={<ModuleRoute moduleKey="crm_master"><BuyerLedgerCreation /></ModuleRoute>} />
              <Route path="crm-master/edit-client/:id" element={<ModuleRoute moduleKey="crm_master"><BuyerLedgerCreation /></ModuleRoute>} />
              <Route path="crm-master/client-list" element={<ModuleRoute moduleKey="crm_master"><ClientList /></ModuleRoute>} />
              <Route path="general-master/wrt-buyer" element={<ModuleRoute moduleKey="general_master"><WRTBuyer /></ModuleRoute>} />
              <Route path="product/add-product" element={<ModuleRoute moduleKey="add_product"><ProductMaster /></ModuleRoute>} />
              <Route path="product/edit-product/:uid" element={<ModuleRoute moduleKey="add_product"><ProductMaster /></ModuleRoute>} />
              <Route path="product/catalog" element={<ModuleRoute moduleKey="catalogue"><Catalog /></ModuleRoute>} />
              <Route path="product/cart" element={<ModuleRoute moduleKey="view_cart"><Cart /></ModuleRoute>} />
              <Route path="product/client-catalog" element={<ModuleRoute moduleKey="client_catalogue"><ClientCatalog /></ModuleRoute>} />
              <Route path="company-details" element={<ModuleRoute moduleKey="company_master"><CompanyDetails /></ModuleRoute>} />
              <Route path="sales" element={<Sales />} />
              <Route path="product/authorize" element={<ModuleRoute moduleKey="product_authorization"><ProductAuthorization /></ModuleRoute>} />
              <Route path="product/proforma-invoice" element={<ModuleRoute moduleKey="proforma_invoice"><ProformaInvoice /></ModuleRoute>} />
              <Route path="order/create" element={<ModuleRoute moduleKey="order_creation"><OrderCreation /></ModuleRoute>} />
              <Route path="order/edit/:id" element={<ModuleRoute moduleKey="order_creation"><OrderCreation /></ModuleRoute>} />
              <Route path="order/search" element={<ModuleRoute moduleKey="order_search"><OrderSearch /></ModuleRoute>} />
              <Route path="order/authorize" element={<ModuleRoute moduleKey="order_authorization"><OrderAuthorization /></ModuleRoute>} />
              <Route path="user/access-control" element={<ModuleRoute moduleKey="user_access_control"><UserAccessControl /></ModuleRoute>} />
              <Route path="dms" element={<ModuleRoute moduleKey="dms"><DMS /></ModuleRoute>} />
            </Route>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </CompanyProvider>
    </AuthProvider>
  );
}

export default App;
